export default __webpack_public_path__ + "static/media/search.93920907.svg";